import React, { ComponentProps } from "react";
import classNames from "classnames";

import LinkBase from "components/LinkBase";

/**
 * Tabs may be used as sub-navigation within a site section
 * (e.g. dispensary pages) or within a section of a single page.
 * Tabs will generally be anchor tags (or Next's Link component)
 * when used as sub-navigation between pages.
 */
type Props = {
  active?: boolean;
  children: React.ReactNode;
  className?: string;
} & ComponentProps<typeof LinkBase>;

const Tab = (props: Props) => {
  const { active, className, ...others } = props;

  const classes = classNames({ "tab--active": active }, "tab", className);

  return <LinkBase className={classes} {...others} />;
};

export default Tab;
